/**
 * package: com.inq.flash.client.control
 * class: FlashVars
 * root Object
 * @constructor
 */
com.inq.flash.client.control.FlashVars = function() {};
$hxClasses['com.inq.flash.client.control.FlashVars'] = com.inq.flash.client.control.FlashVars;
/** @private @type {Array} */
com.inq.flash.client.control.FlashVars.__name__ = ["com","inq","flash","client","control","FlashVars"];
/** @private @type {com.inq.utils.Dictionary} */
com.inq.flash.client.control.FlashVars._flashVars = null;
/** @type {null} */
com.inq.flash.client.control.FlashVars.flashVars = null;

/**
 * getFlashVars
 *
 * $type TFun([],TDynamic(null))
 * public static function getFlashVars():Dynamic
 * @public
 * @static
 * @return {null}
 */
com.inq.flash.client.control.FlashVars.getFlashVars = function() {
	if(null == com.inq.flash.client.control.FlashVars._flashVars) com.inq.flash.client.control.FlashVars.setApplicationParameters();
	return com.inq.flash.client.control.FlashVars._flashVars;
};

/** @type {null} */
com.inq.flash.client.control.FlashVars.persistentFrame = null;
/** @type {null} */
com.inq.flash.client.control.FlashVars.chatID = null;
/** @type {null} */
com.inq.flash.client.control.FlashVars.clickStream = null;
/** @type {string} */
com.inq.flash.client.control.FlashVars.submitURL = null;
/** @type {boolean} */
com.inq.flash.client.control.FlashVars.shutdownPopup = null;
/** @type {boolean} */
com.inq.flash.client.control.FlashVars.continued = null;
/** @type {string} */
com.inq.flash.client.control.FlashVars.tagServerBaseURL = null;
/** @type {string} */
com.inq.flash.client.control.FlashVars.openerID = null;
/** @type {null} */
com.inq.flash.client.control.FlashVars.agentName = null;
/** @type {number} */
com.inq.flash.client.control.FlashVars.openerDelay = null;
/** @type {string} */
com.inq.flash.client.control.FlashVars.userAgent = null;
/** @type {boolean} */
com.inq.flash.client.control.FlashVars.useAgentAlias = null;
/** @type {boolean} */
com.inq.flash.client.control.FlashVars.overrideChatTheme = null;


/**
 * _init
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function _init():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.control.FlashVars._init = function() {
	com.inq.flash.client.control.FlashVars._flashVars = null;
	com.inq.flash.client.control.FlashVars.customerName = null;

	return true;
};


/**
 * getValue - get the
 *
 * $type TFun([{ name => keyName, t => TInst(String,[]), opt => false }],TDynamic(null))
 * public static function getValue(keyName:String):Dynamic
 * @public
 * @static
 * @param {string}  keyName 
 * @return {*}
 */
com.inq.flash.client.control.FlashVars.getValue = function(keyName) {
	return com.inq.flash.client.control.FlashVars.getFlashVars()[keyName];
};

/**
 * Returns boolean value for stringified data in dictionary
 * @param keyName
 * @returns {boolean}
 */
com.inq.flash.client.control.FlashVars.getBooleanValue = function(keyName) {
	return com.inq.flash.client.control.FlashVars.getFlashVars()[keyName] === "true";
};


/**
 * setValue
 *
 * $type TFun([{ name => keyName, t => TInst(String,[]), opt => false },{ name => vl, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public static function setValue(keyName:String, vl:Dynamic)
 * @public
 * @static
 * @param {string}  keyName 
 * @param {null}  vl 
 * @return {void}
 */
com.inq.flash.client.control.FlashVars.setValue = function(keyName,vl) {
	com.inq.flash.client.control.FlashVars.getFlashVars()[keyName] = vl;
};


/**
 * setAgentName
 *
 * $type TFun([{ name => valu, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * private static function setAgentName(valu:String):Void
 * @private
 * @static
 * @param {string}  valu 
 * @return {void}
 */
com.inq.flash.client.control.FlashVars.setAgentName = function(valu) {
	if(valu == null || valu == "null" || StringTools.trim(valu) == "") valu = "Jessica";
	com.inq.flash.client.control.FlashVars.getFlashVars()["agentName"] = valu;
};

/**
 * Set automaton data map
 *
 * @param val map of keys/values that pass to automaton
 */
com.inq.flash.client.control.FlashVars.setAutomatonSpecData = function (val) {
	com.inq.flash.client.control.FlashVars.setValue("automatonSpecData", val);
};

com.inq.flash.client.control.FlashVars.getAutomatonSpecData = function () {
	return com.inq.flash.client.control.FlashVars.getValue("automatonSpecData");
};

/**
 * getUserAgent
 *
 * $type TFun([],TInst(String,[]))
 * private static function getUserAgent():String
 * @private
 * @static
 * @return {string}
 */
com.inq.flash.client.control.FlashVars.getUserAgent = function() {
	return com.inq.flash.client.control.FlashVars.getValue("userAgent");
};


/**
 * getChatID
 *
 * $type TFun([],TInst(String,[]))
 * public static function getChatID():String
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.control.FlashVars.getChatID = function() {
	try {
		return com.inq.flash.client.control.FlashVars.getValue("chatID");
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("FlashVars.getChatID ERROR: " + Std.string(e),{ fileName : "FlashVars.hx", lineNumber : 73, className : "com.inq.flash.client.control.FlashVars", methodName : "getChatID"});
			return null;
		} else throw(e);
	}
};


/**
 * getClickStream
 *
 * $type TFun([],TInst(String,[]))
 * private static function getClickStream():String
 * @private
 * @static
 * @return {string}
 */
com.inq.flash.client.control.FlashVars.getClickStream = function() {
	/** @type {?string} */
	var datum = com.inq.flash.client.control.FlashVars.getValue("clickStream");
	return datum;
};


/**
 * getSubmitURL
 *
 * $type TFun([],TInst(String,[]))
 * private static function getSubmitURL():String
 * @private
 * @static
 * @return {string}
 */
com.inq.flash.client.control.FlashVars.getSubmitURL = function() {
	return com.inq.flash.client.control.FlashVars.getValue("submitURL");
};


/**
 * getShutdownPopup
 *
 * $type TFun([],TEnum(Bool,[]))
 * private static function getShutdownPopup():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.control.FlashVars.getShutdownPopup = function() {
	return com.inq.flash.client.control.FlashVars.getValue("shutdownPopup");
};


/**
 * isContinued
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function isContinued():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.control.FlashVars.isContinued = function() {
	return Std.parseInt("" + Std.string(com.inq.flash.client.control.FlashVars.getValue("continued"))) == 1;
};


/**
 * getTagServerBaseURL
 *
 * $type TFun([],TInst(String,[]))
 * private static function getTagServerBaseURL():String
 * @private
 * @static
 * @return {string}
 */
com.inq.flash.client.control.FlashVars.getTagServerBaseURL = function() {
	return com.inq.flash.client.control.FlashVars.getValue("tagServerBaseURL");
};

/**
 * getUseAgentAlias
 *
 * private static function getUseAgentAlias():boolean
 * @private
 * @static
 * @return {boolean}
 */
com.inq.flash.client.control.FlashVars.getUseAgentAlias = function () {
    return com.inq.flash.client.control.FlashVars.getValue("useAgentAlias");
};

/**
 * getOverrideChatTheme
 *
 * private static function getOverrideChatTheme():boolean
 * @private
 * @static
 * @return {boolean}
 */
com.inq.flash.client.control.FlashVars.getOverrideChatTheme = function () {
    return com.inq.flash.client.control.FlashVars.getValue("overrideChatTheme");
};


/**
 * getOpenerID
 *
 * $type TFun([],TInst(String,[]))
 * private static function getOpenerID():String
 * @private
 * @static
 * @return {string}
 */
com.inq.flash.client.control.FlashVars.getOpenerID = function() {
	return com.inq.flash.client.control.FlashVars.getValue("openerID");
};


/**
 * getAgentName
 *
 * $type TFun([],TInst(String,[]))
 * private static function getAgentName():String
 * @private
 * @static
 * @return {string}
 */
com.inq.flash.client.control.FlashVars.getAgentName = function() {
	if (com.inq.utils.Util.getConfig("agentName")) {
		return com.inq.utils.Util.getConfig("agentName");
	}
	return com.inq.flash.client.control.FlashVars.getValue("agentName");
};

/**
 * Returns the value of customer name from the cookie.
 * @returns {?string}
 */
com.inq.flash.client.control.FlashVars.getCustomerDisplayName = function() {
	return com.inq.flash.client.control.PersistenceManager.GetValue(CUSTOMER_DISPLAY_NAME, null);
};

/**
 * getCustomerName
 *
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.control.FlashVars.getCustomerName = function() {
	if(com.inq.flash.client.control.FlashVars.customerName == null){
		var customerDisplayName = com.inq.flash.client.control.FlashVars.getCustomerDisplayName();
		if(customerDisplayName == null || customerDisplayName == "") {
            if (com.inq.utils.Util.getConfig("customerName")) {
                customerDisplayName = com.inq.utils.Util.getConfig("customerName");
            } else {
                customerDisplayName = com.inq.flash.client.control.FlashVars.getValue("userName");
            }
		}
		com.inq.flash.client.control.FlashVars.setCustomerName(customerDisplayName);
	}
	return com.inq.flash.messagingframework.StringUtils.htmlEncode(com.inq.flash.client.control.FlashVars.customerName);
};


/**
 * setCustomerName
 *
 * @public
 * @static
 * @return {string}
 */
com.inq.flash.client.control.FlashVars.setCustomerName = function(customerName, saveCookie) {
	com.inq.flash.client.control.FlashVars.customerName = customerName;
	Application.application.updateCustomerName(customerName);
	if(saveCookie == true){
		com.inq.flash.client.control.PersistenceManager.SetValue(CUSTOMER_DISPLAY_NAME, customerName);
	}
};

/**
 * Checks that the customer name was changed manually (e.g. via the CustomerNameInputField),
 * by checking that value from cookie is not equal any value from settings.
 * @see com.inq.ui.CustomerNameInputField
 * @returns {boolean}
 */
com.inq.flash.client.control.FlashVars.isCustomerNameUpdated = function() {
	/** @type {?string} */
	var customerDisplayName = com.inq.flash.client.control.FlashVars.getCustomerDisplayName();
	/** @type {?string} */
	var customerName = com.inq.utils.Util.getConfig("customerName");
	/** @type {?string} */
	var userName = com.inq.flash.client.control.FlashVars.getValue("userName");
	if (customerDisplayName) {
		/* In the first place check the customerName in accordance with them priority.
		 * @see: com.inq.flash.client.control.FlashVars.getCustomerName
		 */
		return (customerName && customerName != customerDisplayName)
			|| (userName && userName != customerDisplayName);
	} else {
		return false;
	}
};

/**
 * getOpenerDelay
 *
 * $type TFun([],TInst(Int,[]))
 * private static function getOpenerDelay():Int
 * @private
 * @static
 * @return {number}
 */
com.inq.flash.client.control.FlashVars.getOpenerDelay = function() {
	return com.inq.flash.client.control.FlashVars.getValue("openerDelay");
};

com.inq.flash.client.control.FlashVars.getWindowId = function () {
	return 	com.inq.flash.client.control.FlashVars.getValue(com.inq.flash.client.data.MessageFields.WINDOW_ID_PARAM);
};

com.inq.flash.client.control.FlashVars.isSecureWithCustToken = function () {
	return com.inq.flash.client.control.FlashVars.getBooleanValue(com.inq.flash.client.data.MessageFields.KEY_SECURE_WITH_CUST_TOKEN);
};

com.inq.flash.client.control.FlashVars.getPersistentCustomerID = function () {
	return 	com.inq.flash.client.control.FlashVars.getValue(com.inq.flash.client.data.MessageFields.KEY_SECURE_CUST_TOKEN);
};

/**
 * setApplicationParameters
 *
 * $type TFun([],TInst(com.inq.utils.Dictionary,[]))
 * private static function setApplicationParameters():Dictionary
 * @private
 * @static
 * @return {com.inq.utils.Dictionary}
 */
com.inq.flash.client.control.FlashVars.setApplicationParameters = function() {
	com.inq.flash.client.control.FlashVars._flashVars = new com.inq.utils.Dictionary();
	/** @type {Array} */
	var keyz = com.inq.utils.Util.fields(Application.application.parameters);
	haxe.Log.trace("MainApplication.parameters=" + Std.string(Application.application.parameters),
		{
			fileName: "FlashVars.hx",
			lineNumber: 100,
			className: "com.inq.flash.client.control.FlashVars",
			methodName: "setApplicationParameters"
		});
	if (null == Application.application.parameters) {
		haxe.Log.trace("ERROR: no parameters", {
			fileName: "FlashVars.hx",
			lineNumber: 102,
			className: "com.inq.flash.client.control.FlashVars",
			methodName: "setApplicationParameters"
		});
	}
	for (var j = 0; j < keyz.length; j++) {
		/** @type {string} */
		var keyName = keyz[j];
		/** @type {string} */
		var datum = Application.application.parameters[keyName];

		try {
			com.inq.flash.client.control.FlashVars.setValue(keyName, datum);
			haxe.Log.trace("FlashVars.hx: setApplicationParameters: " + keyName + " = " + datum, {
				fileName: "FlashVars.hx",
				lineNumber: 111,
				className: "com.inq.flash.client.control.FlashVars",
				methodName: "setApplicationParameters"
			});
		} catch (e) {
			if (js.Boot.__instanceof(e, Error)) {
				haxe.Log.trace("FlashVars.hx: setApplicationparameters: Error" + Std.string(e),
					{
						fileName: "FlashVars.hx",
						lineNumber: 113,
						className: "com.inq.flash.client.control.FlashVars",
						methodName: "setApplicationParameters"
					});
			} else {
				throw(e);
			}
		}
	}
	com.inq.flash.client.control.FlashVars.setupFlashVar("chatID","-1");
	
	/**
	 * Special code for getting the default values from the messageText
	 */
	com.inq.flash.client.control.FlashVars.setupFlashVar("continued","0");

	// "c" means that chat is continued, is used in IJSF, see ChatMgr#isV3Continue
	var isCEAPIPostChatSurveyMode = com.inq.flash.client.control.FlashPeer.isCEAPIPostChatSurveyMode();
	com.inq.flash.client.control.PersistenceManager.SetValue(CHAT_CONTINUED, !isCEAPIPostChatSurveyMode ? 1 : 0);

	com.inq.flash.client.control.FlashVars.setupFlashVar("iframeURL","http://sb3.conversive.com/gui_gamefly/chat.html");
	com.inq.flash.client.control.FlashVars.setupFlashVar("agentName","Jessica");
	com.inq.flash.client.control.FlashVars.setupFlashVar("shutdownPopup","false");
	com.inq.flash.client.control.FlashVars.setupFlashVar("userName","Visitor");
	com.inq.flash.client.control.FlashVars.setupFlashVar("delay","0");
	com.inq.flash.client.control.FlashVars.setupFlashVar("submitURL","chatrouterv3.inq.com");
	com.inq.flash.client.control.FlashVars.setupFlashVar("clickStream","");
	com.inq.flash.client.control.FlashVars.setupFlashVar("windowId", "-1");
	com.inq.flash.client.control.FlashVars.setValue("shutdownPopup",com.inq.flash.client.control.FlashVars.getValue("shutdownPopup") == "true");
	com.inq.flash.client.control.FlashVars.setupFlashVar("openerDelay","6");
	com.inq.flash.client.control.FlashVars.setupFlashVar("tagServerBaseURL","https://tagserverv3.inq.com");
	
	/*
	 * PR-145
	 * Make sure that the protocol matches the host page.
	 */
	/** @type {?string} */
	var sTagServer = com.inq.flash.client.control.FlashVars.getValue("tagServerBaseURL");
	/*  ensure that the tag server has a slash at the end. */
	if(HxOverrides.substr(sTagServer,sTagServer.length - 1,null) != "/") {
		sTagServer += "/";
		com.inq.flash.client.control.FlashVars.setValue("tagServerBaseURL",sTagServer);
	}
	/*  now display all flashvars */
	/** @type {string} */
	var sF = "\n";
	/** @type {Array} */
	var keyz1 = com.inq.utils.Util.fields(com.inq.flash.client.control.FlashVars._flashVars);
	for (var i = 0; i < keyz1.length; i++) {
		/** @type {string} */
		var elmt = keyz1[i];
		/** @type {string} */
		var val = com.inq.flash.client.control.FlashVars._flashVars[elmt];
		/** @type {string} */
		var typ = " ";


		typ = typ.charAt(0).toUpperCase() + HxOverrides.substr(typ,1,null);
		if("String" == typ) val = "\"" + Std.string(val) + "\"";
		sF += "FlashVars.flashVars." + elmt + ":" + typ + "=" + Std.string(val) + ";\n";
	}
	haxe.Log.trace(sF,{ fileName : "FlashVars.hx", lineNumber : 188, className : "com.inq.flash.client.control.FlashVars", methodName : "setApplicationParameters"});
	return com.inq.flash.client.control.FlashVars._flashVars;
};


/**
 * setupFlashVar
 *
 * $type TFun([{ name => name, t => TInst(String,[]), opt => false },{ name => defValue, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * private static function setupFlashVar(name:String, defValue:Dynamic):Void
 * @private
 * @static
 * @param {string}  name 
 * @param {null}  defValue 
 * @return {void}
 */
com.inq.flash.client.control.FlashVars.setupFlashVar = function(name,defValue) {
	try {
		/** @type {?string} */
		var _datum = null;
		try {
			_datum = com.inq.flash.client.control.FlashVars.getValue(name);
		} catch( e ) {
			if( js.Boot.__instanceof(e,Error) ) {
				_datum = null;
			} else throw(e);
		}
		
		if(_datum == null) com.inq.flash.client.control.FlashVars.setValue(name,defValue);
	} catch( e ) {
		if( js.Boot.__instanceof(e,Error) ) {
			haxe.Log.trace("FlashVars.setupFlashVars: ERROR: " + Std.string(e),{ fileName : "FlashVars.hx", lineNumber : 213, className : "com.inq.flash.client.control.FlashVars", methodName : "setupFlashVar"});
			com.inq.flash.client.control.FlashVars.setValue(name,defValue);
		} else throw(e);
	}
};


/**
 * get - get values of the flashvars from the map (dictionary)
 *
 * $type TFun([{ name => key, t => TInst(String,[]), opt => false }],TInst(String,[]))
 * public static function get(key:String):String
 * @public
 * @static
 * @param {string}  key - the map's key for retrieving the value 
 * @return {string} - the value associated with the key
 */
com.inq.flash.client.control.FlashVars.get = function(key) {
	com.inq.flash.client.control.FlashVars.getFlashVars();/* Make sure that the map has been initialized */
	return com.inq.flash.client.control.FlashVars._flashVars[key];/* return the value from the map */
};

/** @type {com.inq.flash.client.control.FlashVars} */
com.inq.flash.client.control.FlashVars.prototype.__class__ = com.inq.flash.client.control.FlashVars;
/** @private @type {string} */
com.inq.flash.client.control.FlashVars.customerName = null;
